import {useSettingsStore} from "@/store/settings.ts";

/**
 * A pre-configured fetch client that handles URL construction,
 * default headers, and consistent error handling.
 */
export const apiClient = {
    async fetch<T>(endpoint: string, options?: RequestInit): Promise<T> {
        const settings = useSettingsStore();
        const baseUrl = window.appConfig.apiUrl;

        // Construct the full URL by combining the base URL and the endpoint.
        const fullUrl = new URL(`/api/clientapp/${endpoint}`, `https://${baseUrl}`).href;

        const defaultHeaders = {
            'Content-Type': 'application/json',
            'Accept-Language': settings.cultureInfo
        };

        const finalOptions: RequestInit = {
            ...options,
            headers: {
                ...defaultHeaders,
                ...options?.headers,
            },
        };

        const response = await fetch(fullUrl, finalOptions);

        if (!response.ok) {
            //todo ErrorHandling here
            if (response.status === 401) {

                setTimeout(() => {
                    window.location.href = '/Authent/Logout';
                }, 2000);

                throw new Error('Unauthorized - redirecting to logout');
            }
            // todo > You could add more advanced error handling here,
            // like parsing an error response body.
            throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
        }

        // Handle responses that don't have a body (e.g., HTTP 204 No Content).
        if (response.status === 204) {
            return null as T;
        }

        return response.json();
    }
};
